export class ConfigKey {
    public code: string;
    public id: string;
    public scopes: number;
    public type: string;
    public version: number;
    public parentId: string;
}
